module.exports = __webpack_public_path__ + "img/Ndaytrip.de6ae2e5.png";